import React, { useState, useContext, useMemo } from "react"
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Box, Button, TextField, InputAdornment } from '@mui/material';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import PageContentWrapper from "../components/PageContentWrapper"
import ScansContext from "../contexts/ScansContext"
import CandidatRow, { infosStatut } from "../components/scans/CandidatRow"

import searchIcon from "../images/searchIcon.svg"
import { Users as UsersIcon } from 'react-feather';

// S8 : page « Applicants » de la maquette — tous les candidats de tous les
// scans du recruteur, avec recherche et acces direct au scan concerne.
// Point 20 : la ligne candidat vient du composant partage CandidatRow, le
// meme que la page d'une offre.

const Applicants = () => {
  const navigate = useNavigate();
  const { isLoaded, scans } = useContext(ScansContext)
  const [recherche, setRecherche] = useState("")

  // aplatit tous les candidats de tous les scans
  const candidats = useMemo(() => {
    const liste = []
    ;(scans || []).forEach((scan) => {
      ;(scan?.userIDs || []).forEach((user) => {
        const res = (scan?.userResults || []).find((el) => el.userID === user.userID)
        const { progress, statut, result } = infosStatut(res)
        liste.push({
          id : user.userID,
          nom : user?.userName,
          email : user?.userEmail,
          compteActive : user?.actived === "true",
          scanNom : scan?.name,
          scanID : scan?.id,
          progression : progress,
          statut,
          resultat : result,
        })
      })
    })
    return liste
  }, [scans])

  const filtres = useMemo(() => {
    const q = recherche.trim().toLowerCase()
    if (!q) return candidats
    return candidats.filter((c) =>
      (c.nom || "").toLowerCase().includes(q) ||
      (c.email || "").toLowerCase().includes(q) ||
      (c.scanNom || "").toLowerCase().includes(q)
    )
  }, [candidats, recherche])

  return (
    <>
      <Helmet><title>Candidats | TheScan</title></Helmet>
      <PageContentWrapper
        title="Candidats"
        onglets={[{
          title: "Tous",
          icon : <UsersIcon size="16px"/>,
          onClick : () => { },
        }]}
      >
        <Box sx={{display:"flex", flexDirection:"column", flex:1, gap:"20px", maxWidth:"100%"}}>
          <TextField
            placeholder="Rechercher un candidat, un email, un scan…"
            value={recherche}
            onChange={(e) => setRecherche(e.target.value)}
            variant="outlined"
            sx={{
              maxWidth:"420px",
              background:"white",
              "& .MuiInputBase-input" : { color:"black" },
            }}
            InputProps={{
              startAdornment : (
                <InputAdornment position="start">
                  <img src={searchIcon} style={{width:"18px", height:"18px", opacity:0.6}} alt=""/>
                </InputAdornment>
              ),
            }}
          />

          <Box sx={{fontSize:"14px", color:"#565656"}}>
            {filtres.length} candidat{filtres.length > 1 ? "s" : ""}
            {recherche ? ` sur ${candidats.length}` : ""}
          </Box>

          {filtres.map((c, index) => {
            return (
              <CandidatRow
                key={index}
                nom={c.nom}
                email={c.email}
                compteActive={c.compteActive}
                progression={c.progression}
                statut={c.statut}
                resultat={c.resultat}
                scanNom={c.scanNom}
                clickable
                onClick={() => { navigate('/app/scan/' + c.scanID) }}
                action={<ChevronRightIcon sx={{height:"40px", width:"40px"}}/>}
              />
            )
          })}

          {/* Point 21 : jamais d'etat vide sans action — inviter si un scan
              existe, sinon creer un scan d'abord */}
          {(isLoaded === true && filtres.length === 0) &&
            <Box sx={{
              padding:"40px",
              textAlign:"center",
              color:"#565656",
              background:"white",
              border:"1px solid #E7E7E7",
              display:"flex",
              flexDirection:"column",
              alignItems:"center",
              gap:"20px",
            }}>
              {candidats.length === 0 ? (
                <>
                  {(scans || []).length > 0 ? (
                    <>
                      <Box>Aucun candidat invité pour le moment.</Box>
                      <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        endIcon={<ChevronRightIcon/>}
                        onClick={() => {
                          // un seul scan : on va directement inviter dessus
                          navigate(scans.length === 1 ? '/app/scan/' + scans[0]?.id : '/app/scans')
                        }}
                      >
                        Inviter un candidat
                      </Button>
                    </>
                  ) : (
                    <>
                      <Box>Créez d'abord un scan pour pouvoir inviter des candidats.</Box>
                      <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        endIcon={<ChevronRightIcon/>}
                        onClick={() => { navigate('/app/createScan') }}
                      >
                        Créer un scan
                      </Button>
                    </>
                  )}
                </>
              ) : (
                "Aucun candidat ne correspond à cette recherche."
              )}
            </Box>
          }
        </Box>
      </PageContentWrapper>
    </>
  )
}

export default Applicants
